export default __webpack_public_path__ + "media/images/guests-7d6c986cb69f4fd1dedd96da940b2836.svg";